import Tags from '../../../../../components/Tags/Tags';

export default Tags;
